<template>
  <div class="adminmember">
    <Header msg="editor" />

    <!-- label for table  -->
    <!-- start  -->
    <div class="mt-5 container">
      <h1 class="text-center">Quản lý nv</h1>
    </div>
    <!-- end -->

    <!-- start option -->
    <div class="d-flex justify-content-end container">
      <button class="btn btn-sm bg-dark text-white" @click="actived()">
        <i class="fas fa-user"></i>
      </button>
      <button class="btn btn-sm bg-info text-white" @click="deactived()">
        <i class="fas fa-user-times"></i>
      </button>
      <button class="btn btn-sm bg-dark text-white" @click="toggle = !toggle">
        <i class="fas fa-eye"></i>
      </button>
      <button class="btn btn-sm bg-success text-white" @click="created()">
        <i class="fas fa-plus-circle"></i>
      </button>
      <button class="btn btn-sm bg-danger text-white" @click="deleted()">
        <i class="fas fa-trash"></i>
      </button>
      <button class="btn btn-sm bg-primary text-white" @click="saved()">
        <i class="fas fa-save"></i>
      </button>
    </div>
    <!-- end -->

    <div id="table-responsive" class="container">
      <!-- start table -->
      <table
        class="table table-response table-bordered table-striped table-sm mx-auto"
      >
        <tr class="bg-dark text-white table-striped">
          <th class="th-sm">@</th>
          <th class="th-sm">#</th>
          <th class="th-sm">ID</th>
          <th class="th-sm">Tên</th>
          <th class="th-sm">Tên đăng nhập</th>
          <th class="th-sm">Mật khẩu</th>
          <th v-if="toggle" class="th-sm">Vai trò</th>
          <th v-if="toggle" class="th-sm">Giới tính</th>
          <th  v-if="toggle" class="th-sm">Địa chỉ</th>
          <th v-if="toggle"  class="th-sm">SDT</th>
          <th v-if="toggle" class="th-sm">Facebook</th>
          <th v-if="toggle" class="th-sm">Ngày tạo</th>
          <th v-if="toggle" class="th-sm">Thuộc</th>
          <th v-if="toggle" class="th-sm">Trạng thái</th>
        </tr>
        <!-- add data  -->
        <tr>
          <td>
            <input class="btn short" type="checkbox" disabled />
          </td>
          <td>{{ 0 }}</td>
          <td>
            <input class="short" type="text" v-model="newUsers.id" disabled />
          </td>
          <td>
            <input class="short" type="text" v-model="newUsers.name" required />
          </td>
          <td>
            <input
              class="short"
              type="text"
              v-model="newUsers.username"
              required
            />
          </td>
          <td>
            <input
              class="short"
              type="text"
              v-model="newUsers.password"
              required
            />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="newUsers.role" disabled />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="newUsers.gender" />
          </td>
          <td v-if="toggle" >
            <input class="short" type="text" v-model="newUsers.address" />
          </td>
          <td v-if="toggle" >
            <input class="short" type="text" v-model="newUsers.phone" />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="newUsers.facebook" />
          </td>
          <td v-if="toggle">
            <input
              class="short"
              type="text"
              v-model="newUsers.created"
              disabled
            />
          </td>
          <td v-if="toggle">
            <input
              class="short"
              type="text"
              v-model="newUsers.owned"
              disabled
            />
          </td>
          <td v-if="toggle"><input disabled class="short" type="text" v-model="newUsers.active"></td>
        </tr>

        <!-- data view -->
        <tr v-for="(v, k) in partUsers" :key="k">
          <td>
            <input
              class="btn short"
              type="checkbox"
              v-bind:value="v"
              v-model="checkboxed"
            />
          </td>
          <td>{{ k }}</td>
          <td>
            <input class="short" type="text" v-model="v.id" disabled />
          </td>
          <td>
            <input class="short" type="text" v-model="v.name" required />
          </td>
          <td>
            <input class="short" type="text" v-model="v.username" required />
          </td>
          <td>
            <input class="short" type="text" v-model="v.password" required />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="v.role" disabled />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="v.gender" />
          </td>
          <td v-if="toggle" >
            <input class="short" type="text" v-model="v.address" />
          </td>
          <td v-if="toggle" >
            <input class="short" type="text" v-model="v.phone" />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="v.facebook" />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="v.created" disabled />
          </td>
          <td v-if="toggle">
            <input class="short" type="text" v-model="v.owned" disabled />
          </td>
          <td v-if="toggle"><input class="short" type="text" v-model="v.active"></td>
        </tr>
      </table>

      <!-- end  -->
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  props: {},

  components: {
    Header,
    Footer
  },

  data() {
    return {
      partUsers: [],
      allUsers: [],
      toggle: false,
      choise: false,
      checkboxed: [],
      newUsers: {
        id: "NV" + new Date().getTime(),
        username: "",
        password: "",
        name: "",
        role: "member",
        gender: "",
        address: "",
        phone: "",
        facebook: "",
        created:
          ("0" + new Date().getDate()).slice(-2) +
          "/" +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          "/" +
          new Date().getFullYear(),
        owned: sessionStorage.getItem("id"),
        active: "on"
      }
    };
  },

  methods: {
    actived() {
      this.partUsers = this.allUsers.filter(e => {
        return e.active == "on";
      });
    },

    deactived() {
      this.partUsers = this.allUsers.filter(e => {
        return e.active == "off";
      });
    },

    created() {
      fetch(
        "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts/search?password=" +
          this.newUsers.password
      )
        .then(response => response.json())
        .then(datax => {
          console.log(datax);
          if (datax.length == 0) {
            fetch(
              "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts",
              {
                method: "POST",
                mode: "cors",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(this.newUsers)
              }
            )
              .then(r => r.json())
              .then(data => {
                // alert("Tạo nhân viên thành công !");
              })
              .catch(error => {
                console.log(error);
              });
            this.allUsers.push(this.newUsers);
            this.newUsers = {
              id: "NV" + new Date().getTime(),
              username: "",
              password: "",
              name: "",
              role: "member",
              gender: "",
              address: "",
              phone: "",
              facebook: "",
              created:
                ("0" + new Date().getDate()).slice(-2) +
                "/" +
                ("0" + (new Date().getMonth() + 1)).slice(-2) +
                "/" +
                new Date().getFullYear(),
              owned: sessionStorage.getItem("id"),
              active: "on"
            };
            alert("Tạo thành công");
          }
          if (datax.length != 0) {
            alert("Chọn mật khẩu khác");
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    deleted() {
      for (let i = 0; i < this.checkboxed.length; i++) {
        // Update the "Name" of the first row to "Jack Doe"
        fetch(
          "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts/id/" +
            this.checkboxed[i].id,
          {
            method: "PATCH",
            mode: "cors",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              active: "off"
            })
          }
        )
          .then(r => r.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.log(error);
          });
      }
      alert("Đã xóa thành công");
      this.checkboxed = [];
    },

    saved() {
      for (let i = 0; i < this.checkboxed.length; i++) {
        // Update the "Name" of the first row to "Jack Doe"
        fetch(
          "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts/id/" +
            this.checkboxed[i].id,
          {
            method: "PATCH",
            mode: "cors",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              username: this.checkboxed[i].username,
              password: this.checkboxed[i].password,
              name: this.checkboxed[i].name,
              role: this.checkboxed[i].role,
              gender: this.checkboxed[i].gender,
              address: this.checkboxed[i].address,
              phone: this.checkboxed[i].phone,
              facebook: this.checkboxed[i].facebook,
              created: this.checkboxed[i].created,
              owned: this.checkboxed[i].owned,
              active: this.checkboxed[i].active
            })
          }
        )
          .then(r => r.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.log(error);
          });
      }
      alert("Đã lưu");
      this.checkboxed = [];
    }
  },

  beforeCreate() {
    fetch(
      "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts"
    )
      .then(r => r.json())
      .then(data => {
        this.allUsers = this.partUsers = data.filter(e => {
          return e.owned == sessionStorage.getItem("id");
        });
      })
      .catch(err => console.log(err));
  }
};
</script>

<style lang="css" scoped>
#table-responsive {
  max-height: 45rem;
  overflow: auto;
}
table,
tr,
td {
  margin: 0;
  padding: 0;
}
input {
  border: none;
  min-height: max-content;
  max-width: max-content;
  text-align: center;
}
.short {
  max-width: 100%;
}
.checkbox label:after,
.radio label:after {
  content: "";
  display: table;
  clear: both;
}
.checkbox .cr,
.radio .cr {
  position: relative;
  display: inline-block;
  border: 1px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.3em;
  height: 1.3em;
  float: left;
  margin-right: 0.5em;
}
.radio .cr {
  border-radius: 50%;
}
.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.8em;
  line-height: 0;
  top: 50%;
  left: 20%;
}
.radio .cr .cr-icon {
  margin-left: 0.04em;
}
.checkbox label input[type="checkbox"],
.radio label input[type="radio"] {
  display: none;
}
.checkbox label input[type="checkbox"] + .cr > .cr-icon,
.radio label input[type="radio"] + .cr > .cr-icon {
  transform: scale(3) rotateZ(-20deg);
  opacity: 0;
  transition: all 0.3s ease-in;
}
.checkbox label input[type="checkbox"]:checked + .cr > .cr-icon,
.radio label input[type="radio"]:checked + .cr > .cr-icon {
  transform: scale(1) rotateZ(0deg);
  opacity: 1;
}
.checkbox label input[type="checkbox"]:disabled + .cr,
.radio label input[type="radio"]:disabled + .cr {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/EditorMember.vue